//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { mapActions } from 'vuex'
  import Api from '@/service/api/repository/index'
  // 引入本地封装的 vConsole（只需引入即可完成初始化）
  // import '@/libs/vconsole.js'

export default {
  name: 'login',
  data () {
    return {
      group: {
        acount: '',//13720180033
        password: ''//123123
      }
    }
  },
  methods: {
    // 使用 Vuex 的 app/login action 进行登录
    ...mapActions('app', [
      'login'
    ]),
    async Login () {
      if(this.group.acount == ''){
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入账号',
        })
        return
      }
      if(this.group.password == ''){
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入密码',
        })
        return
      }
      let params = {
        username: this.group.acount,
        password: this.group.password,
        token: ''
      }
      try {
        // 通过 Vuex 调用登录接口，结果由 app 模块的 login action 统一处理
        const res = await this.login(params)
        console.info('login action result:', res)

        if (res && res.success) {
          const data = res.data || {}

          this.$vux.toast.show({
            type: 'success',
            text: '登录成功',
          })

          // 保持与原有逻辑兼容：继续写入 Cookie，方便旧代码读取
          if (data.token) this.$cookie.set('token', data.token)
          if (data.id) this.$cookie.set('id', data.id)
          if (data.store_id) this.$cookie.set('store_id', data.store_id)

          setTimeout(() => {
            this.$router.push({path:'/maternal_file'})
          }, 1000)
        } else {
          this.$vux.toast.show({
            type: 'cancel',
            text: (res && res.message) || '登录失败',
          })
        }
      } catch (error) {
        console.error('login error:', error)
        this.$vux.toast.show({
          type: 'cancel',
          text: error.message || '网络错误，请重试',
        })
      }
    }
  },
  created(){
    console.info('欢迎登录')
  }
}



// WEBPACK FOOTER //
// ./src/components/login.vue